import { useState } from 'react';
import {
    Container,
    Content,
    Controls,
    Wrapper
} from './styled';
import { IoIosClose } from 'react-icons/io';
import {
    AiOutlineZoomIn,
    AiOutlineZoomOut
} from 'react-icons/ai';
import {
    FiRotateCcw,
    FiRotateCw,
    FiDownload
} from "react-icons/fi";
import {
    TransformWrapper,
    TransformComponent,
    useControls
} from 'react-zoom-pan-pinch';
import { saveAs } from 'file-saver';
import moment from 'moment';

export function PresentationImage(props) {

    const { src, onClose } = props;
    const [rotate, setRotate] = useState(0);


    function handleDownload() {
        saveAs(src, `webChat4u - ${moment(new Date()).format('DD-MM-yyyy HH:mm')}`)
    };

    const RenderControls = () => {

        const { zoomIn, zoomOut } = useControls();

        return (
            <Controls>
                <div>
                    <span>
                        <AiOutlineZoomOut
                            onClick={() => { zoomOut() }}
                        />
                    </span>
                    <span>
                        <AiOutlineZoomIn
                            onClick={() => { zoomIn() }}
                        />
                    </span>
                    <span>
                        <FiRotateCcw
                            fontSize={20}
                            onClick={() => { setRotate(rotate - 90) }}
                        />
                    </span>
                    <span>
                        <FiRotateCw
                            fontSize={20}
                            onClick={() => { setRotate(rotate + 90) }}
                        />
                    </span>
                    <span>
                        <FiDownload
                            fontSize={20}
                            onClick={() => { handleDownload() }}
                        />
                    </span>
                    <span>
                        <IoIosClose
                            className='icon--close'
                            onClick={() => onClose()}
                        />
                    </span>
                </div>
            </Controls>
        )
    };

    return (
        <Container>
            <TransformWrapper defaultScale={1}>
                <Content>
                    <RenderControls />
                    <Wrapper rotate={rotate}>
                        <TransformComponent>
                            <img
                                src={src}
                                alt="zoomed"
                            />
                        </TransformComponent>
                    </Wrapper>
                </Content>
            </TransformWrapper>
        </Container>
    )
}